/**
 * SearchBar.tsx — Barra de busca textual cross-vault
 */

import { type FormEvent, useState } from 'react'
import { useNavigate } from 'react-router-dom'

interface SearchBarProps {
  initialQuery?: string
  placeholder?: string
  onSearch?: (query: string) => void
}

export function SearchBar({ initialQuery = '', placeholder = 'Buscar no vault...', onSearch }: SearchBarProps) {
  const navigate = useNavigate()
  const [query, setQuery] = useState(initialQuery)

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    const q = query.trim()
    if (!q) return

    if (onSearch) {
      onSearch(q)
    } else {
      navigate(`/search?q=${encodeURIComponent(q)}`)
    }
  }

  return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '8px' }}>
      <input
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={placeholder}
        style={{ flex: 1 }}
      />
      <button type="submit" className="btn btn-primary" disabled={!query.trim()}>
        Buscar
      </button>
    </form>
  )
}
